import { useCallback, useEffect, useState } from 'react';
import { ApiError } from './apiClient';

interface ApiResourceState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
  reload: () => void;
}

/** Shared loading/error/data pattern for the four section pages that each list one resource. */
export function useApiResource<T>(fetcher: () => Promise<T>, deps: unknown[]): ApiResourceState<T> {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    fetcher()
      .then((result) => setData(result))
      .catch((err) => setError(err instanceof ApiError ? err.message : 'Request failed'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, reloadToken]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: () => setReloadToken((t) => t + 1) };
}
